import React from 'react';
import { Button } from 'antd';
import { Translate } from '@above-the-treeline/localization';

export default function AlreadyRegisteredError(): JSX.Element {
	return (
		<div className="registration-modal-link" style={{ display: 'block' }}>
			<Translate id="the_email_address_you_have_provided_is_already_registered_with_edelweiss" />
			<br />
			{Boolean(process.env.REACT_APP_DO_SHOW_PASSWORD_EDITOR) && (
				<Button>
					<Translate id="forgot_password" />
				</Button>
			)}
		</div>
	);
}
